/* Progressive enhancement only. Product submissions remain Shopify native. */
document.addEventListener('change', (event) => {
  if (!event.target.matches('[data-ns-variant]')) return;
  const form = event.target.closest('form');
  const option = event.target.selectedOptions[0];
  const price = form.querySelector('[data-ns-price]');
  const button = form.querySelector('[type="submit"]');
  const promoPrice = form.querySelector('[data-ns-promo-price]');
  if (price) price.textContent = option.dataset.price;
  if (promoPrice) promoPrice.textContent = option.dataset.promoPrice;
  button.disabled = option.disabled;
  button.textContent = option.disabled ? 'Indisponible' : (form.classList?.contains('ns-primary-buy') ? 'Ajouter les 3 pots au panier' : 'Ajouter au panier');
});

// The reminder returns to the real form; it never submits a product implicitly.
function setupNosteaPerlesReminder(root = document) {
  if (typeof window === 'undefined' || !('IntersectionObserver' in window)) return;
  root.querySelectorAll('[data-ns-landing]').forEach((landing) => {
    const form = landing.querySelector('.ns-primary-buy');
    const reminder = landing.querySelector('[data-ns-mobile-buy]');
    if (!form || !reminder || reminder.dataset.ready) return;
    reminder.dataset.ready = 'true';
    const observer = new IntersectionObserver(([entry]) => {
      reminder.hidden = entry.isIntersecting || entry.boundingClientRect.bottom >= 0;
    });
    observer.observe(form);
    document.addEventListener('shopify:section:unload', (event) => {
      if (event.target.contains(landing)) observer.disconnect();
    });
  });
}
setupNosteaPerlesReminder();
if (typeof window !== 'undefined') document.addEventListener('shopify:section:load', (event) => setupNosteaPerlesReminder(event.target));
